import { Box, Text, VStack } from '@chakra-ui/react'
import React from 'react'

const getStartedByCreatingProjectTourGuideContent: React.ReactNode = (
  <Box py={3}>
    <VStack align="flex-start" spacing={2}>
      <Text fontSize="sm" color="gray.700" lineHeight="1.6">
        Get started by creating a project. Click on the projects menu option to view the projects.
      </Text>
    </VStack>
  </Box>
)

export const helpAndSupportHelperTourGuideSteps = [
  {
    selector: '.projects-menu-option',
    content: getStartedByCreatingProjectTourGuideContent
  }
]
